module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./client/app/global/global-update/global-update.component.scss
// module id = ./client/app/global/global-update/global-update.component.scss
// module chunks = main